/**
 * File hero.js.
 * Handles adding classes to elements depending on hero style
 * Handles class changes for slotted hero image on mobile devices
 */

function heroInit($) {
  const heroBlackSpace = $('.black-space');
  const heroWhiteSpace = $('.white-space');
  const heroSpaceSelected = heroBlackSpace.length > 0 ? heroBlackSpace : heroWhiteSpace.length > 0 ? heroWhiteSpace : '';
  const heroImageSlot = $('.hero__image-slot');
  const heroImage = $('.hero__image--above');
  const heroCta = $('.hero__cta--below');
  
  function applyChevrons() {
    // get first and last section siblings, get chevron data
    const heroSpaceClassName = heroBlackSpace.length > 0 ? 'black-space' : heroWhiteSpace.length > 0 ? 'white-space' : '';
    const chevDownClassName = heroSpaceClassName + '__chevron-down';
    const chevUpClassName = heroSpaceClassName + '__chevron-up';
    const elChevDown = heroSpaceSelected.nextAll('.section').first();
    const elChevUp = heroSpaceSelected.nextAll('.section').last();
    const useChev = heroSpaceSelected.attr('data-chevron');
    const chevDownSize = heroSpaceSelected.attr('data-chevron-down');
    const chevUpSize = heroSpaceSelected.attr('data-chevron-up');
    
    // add classes
    if (useChev) {
      elChevDown.addClass(heroSpaceClassName + '__chevron-down');
      elChevUp.addClass(heroSpaceClassName + '__chevron-up');
      heroSpaceSelected.addClass(heroSpaceClassName + '--chevron-below');
      $('.' + chevDownClassName).addClass(chevDownClassName + '--' + chevDownSize);
      $('.' + chevUpClassName).addClass(chevUpClassName + '--' + chevUpSize);
    }
    if (heroSpaceSelected == heroWhiteSpace) {
      $('.self-service-content').addClass('white-space__self-service-content');
      $('.disclaimers').addClass('white-space__disclaimers');
    }
  }

  function moveHeroImage() {
    const heroImageMobileTop = $('.hero__image--mobile-top');
    heroImageMobileTop.appendTo(heroImageSlot);
    // Alter hero markup so resolution changes don't break styles while image is slotted
    $('.hero').addClass('hero--image-slotted');
    $('.hero__content').removeClass('flex');
    $('.header').removeClass('header--logo-nav--left');
  }

  function setPositions() {
    const isOverlap = $('.hero__cta--below-overlap').length > 0;

    // Get heights of the hero image and body to calculate margins
    let imageHeight = $('.hero__image').height();
    let bodyHeight = $('.hero__body').height();

    // For mobile devices, 15px is being used as standard image margin-top and 10px is being used as standard cta margin-top
    if (isOverlap) {
      imageHeight -= 60;
    }

    // Adds margins to image and CTA sections of hero
    $('.hero__cta--below').css('margin-top', imageHeight + 25);
    $('.hero__image--above').css('margin-top', bodyHeight + 15);
  }

  function mobileImageAboveCta() {
    let quickTimer;
    let slowTimer; // catch slow rendering / loading
    
    // Wait for the window to load or be resized before getting heights
    $(window).on('load resize', function() {
      if (typeof isMobile == 'function' && isMobile()) {
        // Clear timeouts
        clearTimeout(quickTimer);	
        clearTimeout(slowTimer);

        // Set timeouts
        quickTimer = setTimeout(setPositions, 100);
        slowTimer = setTimeout(setPositions, 500);
      }
    });
  }

  // Inits
  if (heroSpaceSelected.length > 0) {
    applyChevrons();
  }

  if (heroImageSlot.length > 0 && typeof isMobile == 'function' && isMobile()) {
    moveHeroImage();
  }

  
  if (heroImage.length > 0 && heroCta.length > 0) {
    mobileImageAboveCta();
  }
}
